module.exports = __webpack_public_path__ + "static/7-d5ad10c015ce02e2b39c3b1f05ee51ed.jpg";